module.exports = __webpack_public_path__ + "static/media/writing.2a8c1b74.svg";